import { render } from "./BasicDivider.vue?vue&type=template&id=a4737b72&scoped=true"
import script from "./BasicDivider.vue?vue&type=script&lang=js"
export * from "./BasicDivider.vue?vue&type=script&lang=js"

import "./BasicDivider.vue?vue&type=style&index=0&id=a4737b72&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4737b72"]])

export default __exports__